import React from 'react';
import styles from './Wizard.module.css';

const Wizard = ({ currentStep }) => {
  // Define the steps with number and title
  const steps = [
    { number: 1, title: 'View Company' },
    { number: 2, title: 'View Departments' },
    { number: 3, title: 'Fill Department Details' }
  ];

  return (
    <div className={styles.wizardContainer}>
      {steps.map((step, index) => (
        <div key={index} className={styles.stepContainer}>
          <div
            className={`${styles.stepCircle} 
              ${currentStep === step.number ? styles.active : ''} 
              ${currentStep > step.number ? styles.completed : ''}`}
          >
            {step.number}
          </div>
          <div className={styles.stepLabel}>{step.title}</div>
          {index < steps.length - 1 && <div className={styles.connector} />}
        </div>
      ))}
    </div>
  );
};

export default Wizard;
